import axios from "axios";
import getLanguage from "./getLanguage"

const PLAYFAB_TITLE_IDS = {
    prod: '8C087',
    dev: '634D9',
    danny: '634D9',
    gabriel: '634D9',
    francois: '634D9'
}

const PLAYFAB_EMAIL_TEMPLATES = {
    prod: 'A09520F6C9CB896C',
    dev: 'C3A7CC6A7FE9DE96',
    danny: 'C3A7CC6A7FE9DE96',
    gabriel: 'C3A7CC6A7FE9DE96',
    francois: 'C3A7CC6A7FE9DE96'
}

const PLAYFAB_ADD_OR_UPDATE_FUNCTIONS = {
    prod: 'addOrUpdateUser',
    dev: 'addOrUpdateUser',
    danny: 'addOrUpdateUser',
    gabriel: 'addOrUpdateUser_Gabriel',
    francois: 'addOrUpdateUser'
}

const PLAYFAB_METHODS = {
    REGISTER_PLAYFAB_USER: 'RegisterPlayFabUser',
    LOGIN_WITH_EMAIL_ADDRESS: 'LoginWithEmailAddress',
    LOGIN_WITH_CUSTOM_ID: 'LoginWithCustomID',
    LINK_CUSTOM_ID: 'LinkCustomID',
    LINK_IOS_DEVICE_ID: 'LinkIOSDeviceID',
    LINK_ANDROID_DEVICE_ID: 'LinkAndroidDeviceID',
    SEND_ACCOUNT_RECOVERY_EMAIL: 'SendAccountRecoveryEmail'
}

export const executeAddOrUpdateUser = async (entityToken, uluwebToken, playfabID, newParentPortalAccount) => {
    // https://learn.microsoft.com/en-us/rest/api/playfab/cloudscript/server-side-cloud-script/execute-function
    const url = `https://${PLAYFAB_TITLE_IDS[process.env['REACT_APP_ENV']]}.playfabapi.com/CloudScript/ExecuteFunction`
    const headers = {
        headers: {
            'Content-Type': 'application/json',
            'X-EntityToken': entityToken
        }
    }

    return await axios.post(
        url,
        {
            FunctionName: PLAYFAB_ADD_OR_UPDATE_FUNCTIONS[process.env['REACT_APP_ENV']],
            FunctionParameter: {
                args: {
                    token: uluwebToken,
                    userApiVersion: process.env['REACT_APP_PLAYFAB_API_VERSION'],
                    newParentPortalAccount: newParentPortalAccount,
                    lang: getLanguage()
                },
                playfabID: playfabID,
                p: 1 // Marking as coming from the frontend
            },
            GeneratePlayStreamEvent: true
        },
        headers
    )
}

const getPlayfabClientAPIEndpoint = (method = '') =>
    `https://${PLAYFAB_TITLE_IDS[process.env['REACT_APP_ENV']]}.playfabapi.com/Client/${method}`

const jsonFormHeader = (sessionTicket) => {
    const headers = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    if (sessionTicket)
        headers['headers']['X-Authorization'] = sessionTicket

    return headers
}

export const linkCustomID = async (sessionTicket, customID) =>
    await linkID(sessionTicket, PLAYFAB_METHODS.LINK_CUSTOM_ID, { CustomId: customID })

export const linkAndroidDeviceID = async (sessionTicket, deviceID) =>
    await linkID(sessionTicket, PLAYFAB_METHODS.LINK_ANDROID_DEVICE_ID, { AndroidDeviceId: deviceID })

export const linkIOSDeviceID = async (sessionTicket, deviceID) =>
    await linkID(sessionTicket, PLAYFAB_METHODS.LINK_IOS_DEVICE_ID, { DeviceId: deviceID })

const linkID = async (sessionTicket, method, payloadID) => {
    return await axios.post(
        getPlayfabClientAPIEndpoint(method),
        payloadID,
        jsonFormHeader(sessionTicket)
    )
}

export const registerPlayfabUser = async (email, password) => {
    const payload = {
        Email: email,
        Password: password,
        TitleId: PLAYFAB_TITLE_IDS[process.env['REACT_APP_ENV']],
        RequireBothUsernameAndEmail: false
    }

    return await axios.post(
        getPlayfabClientAPIEndpoint(PLAYFAB_METHODS.REGISTER_PLAYFAB_USER),
        payload,
        jsonFormHeader()
    )
}

export const loginWithEmailAddress = async (email, password) => {
    const payload = {
        Email: email,
        Password: password,
        TitleId: PLAYFAB_TITLE_IDS[process.env['REACT_APP_ENV']],
        RequireBothUsernameAndEmail: false
    }

    return await axios.post(
        getPlayfabClientAPIEndpoint(PLAYFAB_METHODS.LOGIN_WITH_EMAIL_ADDRESS),
        payload,
        jsonFormHeader()
    )
}

export const loginWithCustomID = async (customId) => {
    const payload = {
        CustomId: customId,
        TitleId: PLAYFAB_TITLE_IDS[process.env['REACT_APP_ENV']],
        CreateAccount: true
    }

    return await axios.post(
        getPlayfabClientAPIEndpoint(PLAYFAB_METHODS.LOGIN_WITH_CUSTOM_ID),
        payload,
        jsonFormHeader()
    )
}

export const sendAccountRecoveryEmail = async (email) => {
    const payload = {
        TitleId: PLAYFAB_TITLE_IDS[process.env['REACT_APP_ENV']],
        Email: email,
        EmailTemplateId: PLAYFAB_EMAIL_TEMPLATES[process.env['REACT_APP_ENV']]
    }

    return await axios.post(
        getPlayfabClientAPIEndpoint(PLAYFAB_METHODS.SEND_ACCOUNT_RECOVERY_EMAIL),
        payload,
        jsonFormHeader()
    )
}